import type { CommissionEditQueueViewMode } from "../commissionEditQueue.constants";
import type { RequestContext } from "../commissionEditQueue.types";
import { CommissionEditQueueTable } from "./CommissionEditQueueTable";
import { CommissionEditRequestGrid } from "./CommissionEditRequestGrid";

interface CommissionEditQueueContentProps {
  requests: RequestContext[];
  viewMode: CommissionEditQueueViewMode;
  busyId: number | null;
  rejectingId: number | null;
  rejectNote: string;
  onSelect: (context: RequestContext) => void;
  onApprove: (requestId: number) => void;
  onReject: (requestId: number) => void;
  onStartReject: (requestId: number | null) => void;
  onRejectNote: (note: string) => void;
}

export function CommissionEditQueueContent({
  requests,
  viewMode,
  busyId,
  rejectingId,
  rejectNote,
  onSelect,
  onApprove,
  onReject,
  onStartReject,
  onRejectNote,
}: CommissionEditQueueContentProps) {
  if (viewMode === "grid") {
    return (
      <CommissionEditRequestGrid
        requests={requests}
        busyId={busyId}
        rejectingId={rejectingId}
        rejectNote={rejectNote}
        onSelect={onSelect}
        onApprove={onApprove}
        onReject={onReject}
        onStartReject={onStartReject}
        onRejectNote={onRejectNote}
      />
    );
  }

  return <CommissionEditQueueTable requests={requests} onSelect={onSelect} />;
}
